import React from 'react'
import { Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import InsetSegmentedControl from '../atoms/InsetSegmentedControl'
import { FormFieldError, FormFieldLabel } from '../atoms/FormTextInput'
import { MobilePromotionFormData } from 'src/helpers/mobilePromotionFormValidation'

interface YesNoSegmentProps {
  value: boolean | null
  onChange: (value: boolean | null) => void
}

const fieldClass = 'self-stretch flex flex-col justify-start items-start gap-2'

export const YesNoSegment = ({ value, onChange }: YesNoSegmentProps): JSX.Element => {
  const { t } = useTranslation()
  const options = [
    { value: true, label: t('my_vehicles.promotion_yes') },
    { value: false, label: t('my_vehicles.promotion_no') },
    { value: null, label: t('sell_contract.not_specified') }
  ]

  return <InsetSegmentedControl value={value} onChange={onChange} options={options} className="w-56" />
}

const storedValue = (value: unknown): boolean | null => {
  if (value === 'true') {
    return true
  }
  if (value === 'false') {
    return false
  }
  return null
}

interface YesNoSegmentFieldProps {
  name: keyof MobilePromotionFormData
  label: string
}

export const YesNoSegmentField = ({ name, label }: YesNoSegmentFieldProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Field name={name}>
      {({ input, meta }) => {
        const invalid = Boolean(meta.error) && (Boolean(meta.touched) || Boolean(meta.submitFailed))
        return (
          <div className={fieldClass} data-field={name}>
            <FormFieldLabel label={label} />
            <YesNoSegment
              value={storedValue(input.value)}
              onChange={(next) => {
                if (next === true) {
                  input.onChange('true')
                  return
                }
                if (next === false) {
                  input.onChange('false')
                  return
                }
                input.onChange('')
              }}
            />
            <FormFieldError show={invalid} message={t('my_vehicles.field_required')} />
          </div>
        )
      }}
    </Field>
  )
}
